var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "优惠劵",
            visible: _vm.visible,
            width: "1100px",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _vm.visible
            ? _c("coupon-list", {
                attrs: {
                  handle: _vm.handle,
                  userIds: _vm.userIds,
                  couponData: _vm.coupons,
                  keyNum: _vm.keyNum,
                  userType: _vm.userType,
                },
                on: { getCouponId: _vm.getCouponId },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }